import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import config from '@app/config'

import { SyncCurrentUserStorage } from '@app/hooks'
import { User } from '@app/models'
import { initAIuser } from '@app/services/logging'
import { initGTM } from '@app/services/tracking'
import { initialState as authState } from '@app/store/auth/constants'

import { initialState } from './constants'
import { getCurrentUserThunk, patchLanguageExceptionsThunk } from './thunks'

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    syncCurrentUser: (state, action: PayloadAction<User>) => {
      return {
        ...state,
        currentUser: action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentUserThunk.fulfilled, (state, action) => {
      config.regionalSettings = action.payload.user.regionalSettings || {}
      initAIuser(authState, action.payload.user, action.payload.account)
      initGTM(action.payload.user, action.payload.account)
      return {
        patchingCurrentUser: false,
        currentUser: action.payload.user,
        account: action.payload.account,
        permissions: action.payload.permissions,
        fetchingSucceed: true,
        fetchingPending: false,
      }
    })

    builder.addCase(getCurrentUserThunk.rejected, (state) => {
      return {
        ...state,
        fetchingSucceed: false,
        fetchingPending: false,
      }
    })

    builder.addCase(getCurrentUserThunk.pending, (state) => {
      return {
        ...state,
        fetchingSucceed: false,
        fetchingPending: true,
      }
    })

    builder.addCase(patchLanguageExceptionsThunk.pending, (state) => {
      return {
        ...state,
        patchingCurrentUser: true,
      }
    })

    builder.addCase(patchLanguageExceptionsThunk.rejected, (state) => {
      return {
        ...state,
        patchingCurrentUser: false,
      }
    })

    builder.addCase(patchLanguageExceptionsThunk.fulfilled, (state, action) => {
      SyncCurrentUserStorage(action.payload.user)
      config.regionalSettings = action.payload.user.regionalSettings || {}

      return {
        ...state,
        patchingCurrentUser: false,
        currentUser: action.payload.user,
      }
    })
  },
})

export const { syncCurrentUser } = userSlice.actions
export default userSlice.reducer
